import { render } from "./SkeletonBaseLayoutMobile.vue?vue&type=template&id=01f9d7ec&scoped=true"
import script from "./SkeletonBaseLayoutMobile.vue?vue&type=script&lang=js"
export * from "./SkeletonBaseLayoutMobile.vue?vue&type=script&lang=js"

import "./SkeletonBaseLayoutMobile.vue?vue&type=style&index=0&id=01f9d7ec&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-01f9d7ec"
/* hot reload */
if (module.hot) {
  script.__hmrId = "01f9d7ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('01f9d7ec', script)) {
    api.reload('01f9d7ec', script)
  }
  
  module.hot.accept("./SkeletonBaseLayoutMobile.vue?vue&type=template&id=01f9d7ec&scoped=true", () => {
    api.rerender('01f9d7ec', render)
  })

}

script.__file = "src/ui/skeleton/SkeletonBaseLayoutMobile.vue"

export default script